import {Error, ValidationResult, Validator} from '@/type/validation/result';
import {年書式, 年月書式, 必須入力, 日付書式} from '@/type/validation/validator';
import {納品加重明細出力条件型} from '@/type/custom/teishinkai/納品加重明細出力条件';

export default class 納品加重明細出力条件チェッカー {
  単項目チェック結果: Error[] = [];
  相関チェック結果: Error[] = [];

  constructor(出力条件: 納品加重明細出力条件型) {
    const 出力条件チェック = new ValidationResult(納品加重明細出力条件Validators);
    出力条件チェック.validate(出力条件);
    this.単項目チェック結果 = 出力条件チェック.getErrors;
    this.相関チェック結果 = 相関チェック(出力条件);
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0 || this.相関チェック結果.length > 0;
  }

  errorMessages(): string[] {
    return this.単項目チェック結果.concat(this.相関チェック結果)
      .map((value) => `${value.message}`);
  }

  hasError(name: string): boolean {
    return this.単項目チェック結果.concat(this.相関チェック結果)
      .some((error) => error.name === name);
  }
}

const 対象期間Validator = {
  name: '対象期間区分',
  constraints: [
    {method: 必須入力, message: '対象期間を選択してください'},
  ],
};

const 納品加重明細出力条件Validators: Validator[] = [
  対象期間Validator,
];


function 相関チェック(出力条件: 納品加重明細出力条件型): Error[] {
  const errors: Error[] = [];
  if (出力条件.対象期間区分 === '対象年度') {
    if (出力条件.対象年度 === '' || 出力条件.対象年度 == null) {
      errors.push({index: 1, message: '対象年度を入力してください', constraint: '', name: '対象年度'});
    }
    if (!年書式(出力条件.対象年度)) {
      errors.push({index: 1, message: '対象年度の書式を正しく入力してください', constraint: '', name: '対象年度'});
    }
  }
  if (出力条件.対象期間区分 === '対象年月') {
    if (出力条件.対象年月 === '' || 出力条件.対象年月 == null) {
      errors.push({index: 1, message: '対象年月を入力してください', constraint: '', name: '対象年月'});
    }
    if (!年月書式(出力条件.対象年月)) {
      errors.push({index: 1, message: '対象年月の書式を正しく入力してください', constraint: '', name: '対象年月'});
    }
  }

  return errors;
}
